"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkConfig = exports.messages = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _types = require("../types");

var messages = {
  countryCode: "countryCode: must be either 'nz' or 'au'",
  guid: 'guid: must be a valid guid string',
  userToken: 'userToken: must be a valid userToken string',
  onEvent: 'onEvent: must be a function that will be called with an event object'
};
exports.messages = messages;

var checkConfig = function checkConfig(config) {
  if (undefined === 'local' || undefined) {
    return [];
  }

  return Object.keys(config).reduce(function (acc, key) {
    if (key === 'countryCode' && config.countryCode !== _types.Region.NZ && config.countryCode !== _types.Region.AU) {
      return [].concat((0, _toConsumableArray2.default)(acc), [messages[key]]);
    }

    if (key === 'guid' && !(config.guid && typeof config.guid === 'string')) {
      return [].concat((0, _toConsumableArray2.default)(acc), [messages[key]]);
    }

    if (key === 'userToken' && !(config.userToken && typeof config.userToken === 'string')) {
      return [].concat((0, _toConsumableArray2.default)(acc), [messages[key]]);
    }

    if (key === 'onEvent' && typeof config.onEvent !== 'function') {
      return [].concat((0, _toConsumableArray2.default)(acc), [messages[key]]);
    }

    return acc;
  }, []);
};

exports.checkConfig = checkConfig;